const Mode = {
  ACC_GROUPS: 'ACC_GROUPS',
  ENTITIES: 'ENTITIES',
};
export default Mode;

export const ModeEntity = {
  [Mode.ACC_GROUPS]: {
    label: 'Account Groups',
    value: Mode.ACC_GROUPS,
  },
  [Mode.ENTITIES]: {
    label: 'Entities',
    value: Mode.ENTITIES,
  }
};

export const modeOptions = Object.entries(ModeEntity).map(([key, entity]) => ({label: entity.label, value: key}));
